module.exports = __webpack_public_path__ + "img/global_goods_default.208ec4ad.png";